/* eslint-disable no-script-url */

import React from 'react';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Title from './Title';

const useStyles = makeStyles({
  depositContext: {
    flex: 1,
  },
});

export default function Deposits() {
  const classes = useStyles();
  return (
    <React.Fragment>
      <Title>Meu Plano</Title>
      <Typography component="p" variant="h4">
        R$ 100,00
      </Typography>
      <Typography color="textSecondary" className={classes.depositContext}>
        (plano mensal)
      </Typography>
      <div>
        <Link color="primary" href="javascript:;">
          Fazer upgrade
        </Link>
      </div>
    </React.Fragment>
  );
}
